import { render, staticRenderFns } from "./averagecprce.vue?vue&type=template&id=04ed683b&scoped=true&"
import script from "./averagecprce.vue?vue&type=script&lang=js&"
export * from "./averagecprce.vue?vue&type=script&lang=js&"
import style0 from "./averagecprce.vue?vue&type=style&index=0&id=04ed683b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed683b",
  null
  
)

export default component.exports